import { TApplicationState } from '../../types/redux';

export function getSelectedHouseId(state: TApplicationState) {
  return state.offers.selectedHouseId;
}
